module.exports = __webpack_public_path__ + "img/login-art-3.ff64578.jpg";